import React, { Component } from 'react'
import FormHelperText from '@mui/material/FormHelperText'

const renderFromHelper = ({ touched, error }) => {
    if (!(touched && error)) {
        return
    } else {
        return <FormHelperText className='text-center' style={{ color: '#f44336' }}>{touched && error}</FormHelperText>
    }
}

export default class FieldFileInput extends Component {

    handleFileSelect(e) {
        const { input: { onChange } } = this.props
        let document = "";
        let reader = new FileReader();
        reader.readAsDataURL(e.target.files[0]);
        reader.onload = () => {
            document = reader.result;
            onChange(document)
        };
        reader.onerror = function (error) {
        };
    }

    render() {
        const { input: { value } } = this.props
        const { label, meta: { touched, error } } = this.props
        return (
            <div className='text-center'>
                <div>
                    <input
                        type='file'
                        accept='.jpg, .png, .jpeg, .pdf'
                        style={{ display: 'none' }}
                        onChange={(e) => this.handleFileSelect(e)} ref={(ref) => this.drugLic20B = ref}
                    />
                    <img alt="drug" src={value !== '' ? require('assets/images/camera_3.png') : require('assets/images/camera_1.png')} className='d-block mx-auto' onClick={(e) => this.drugLic20B.click()} />
                </div>
                <label >{label}</label>
                {renderFromHelper({ touched, error })}
            </div>
        )
    }
}